/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React from 'react';

const FormInlineError = ({ message }) => {
	if (!message) {
		return null;
	}

	return (
		<div className="login-form-error" role="alert">
			{message}
		</div>
	);
};

export default FormInlineError;
